/**
 * Une session du BO = un jeton ET l'utilisateur. Seule définition, partagée par PrivateRoute et
 * GuestRoute : jugée différemment de chaque côté (jeton seul d'un côté, jeton + user_id de l'autre),
 * un `user_id` manquant les renvoyait l'un à l'autre en boucle — page blanche.
 */
export const hasStoredSession = (): boolean =>
    localStorage.getItem('token') !== null && localStorage.getItem('user_id') !== null;
